import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, ModalSize, SafetyCorrectiveAction, User } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SafetyCorrectiveActionComponent } from './safety-corrective-action.component'

@Component({
    selector: 'app-safety-corrective-actions',
    templateUrl: './safety-corrective-actions.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SafetyCorrectiveActionsComponent extends BaseComponent {
    public grid: Grid<SafetyCorrectiveAction>

    createdByMap!: DataMap

    constructor() {
        super()
        this.grid = new Grid<SafetyCorrectiveAction>(this.services)
            .setupModalEditing(
                this.services.data.safetyCorrectiveActions,
                'Corrective Action Form',
                SafetyCorrectiveActionComponent,
                () => SafetyCorrectiveAction.createNew(),
                this,
                ModalSize.extraLarge,
            )
            .wrapColumnHeaders()
            .filterBy(item => [item.nearMissDescription, item.damageDone, item.correctionMade, item.createdByName])
        this.grid.canEdit = this.canEdit
        this.grid.canAdd = this.canEdit
        this.grid.canDelete = this.canEdit
        this.refresh()
    }

    public refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.users.queryAllByAction('GetForLookup'), this.services.data.safetyCorrectiveActions.queryAll())
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()

                        const allUsers = result[0] as User[]
                        this.createdByMap = new DataMap(allUsers, 'id', 'displayName')

                        const items = result[1] as SafetyCorrectiveAction[]
                        const nameById = new Map(allUsers.map(u => [u.id, u.displayName]))
                        for (const item of items) {
                            if (!item.createdByName && item.createdByUserId) {
                                item.createdByName = nameById.get(item.createdByUserId) ?? ''
                            }
                        }
                        this.grid.items = items
                    },
                }),
        )
    }

    public get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.SafetyChecklistEdit])
    }
}
